/**
 * A response status from the API
 */
export enum ResponseStatus {
    SUCCESS = 'success',
    ERROR = 'error'
}
